import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// The service now just takes the file and the full, final path.
// The calling component is responsible for building the correct path.
export const uploadFile = async (file, fullPath) => {
  if (!file || !fullPath) {
    throw new Error("File and full storage path are required.");
  }
  const storage = getStorage();
  const fileRef = ref(storage, fullPath);

  console.log(`📤 Uploading file to: ${fullPath}`);
  await uploadBytes(fileRef, file);
  const fileURL = await getDownloadURL(fileRef);
  console.log("✅ File uploaded successfully:", fileURL);
  return { fileURL };
};